import { AuthCredentialsSection } from '../components/AuthCredentialsSection';
import { AuthContactPrompt } from '../components/AuthContactSupport';
import { PageChrome } from '../components/PageChrome';
import { ASSET_OWNER_LOGIN_TYPE } from '../login/authEntryPolicy';
import { useI18n } from '../i18n';
import styles from './AuthRoleLoginPage.module.css';

export type AuthAssetOwnerPageProps = {
  onBack: () => void;
  onShowRegister: () => void;
  onContact: () => void;
  onForgotPassword: () => void;
};

export function AuthAssetOwnerPage({
  onBack,
  onShowRegister,
  onContact,
  onForgotPassword,
}: AuthAssetOwnerPageProps) {
  const { t } = useI18n();

  return (
    <PageChrome title={t('auth.assetOwner.signInTitle')} onBack={onBack}>
      <div className={styles.page}>
        <p className={styles.intro}>{t('auth.assetOwner.signInIntro')}</p>
        <AuthCredentialsSection
          fixedLoginOption={ASSET_OWNER_LOGIN_TYPE}
          roleLabelInTitle={ASSET_OWNER_LOGIN_TYPE}
          enableGoogleSignIn
          showGoogleIntro={false}
          onForgotPassword={() => onForgotPassword()}
        />
        <footer className={styles.footer}>
          <p className={styles.registerRow}>
            {t('auth.portal.noAccount')}{' '}
            <button type="button" className={styles.footerLink} onClick={onShowRegister}>
              {t('auth.assetOwner.registerLink')}
            </button>
          </p>
          <AuthContactPrompt onContact={onContact} />
        </footer>
      </div>
    </PageChrome>
  );
}
